/** Designer usage map: which other screens depend on each tab / slot / field switch.
 *  QA cards and email placeholders are derived from their real definitions;
 *  print + Dock Manager peek mirror BookingPrint.jsx / BookingPeek.jsx (keep in sync). */
import { cardsFor } from "@/components/booking-form/slots/QAConfirmCardsSlot";
import { PLACEHOLDER_SOURCES } from "@/lib/formVisibility";

export const PRINT = {
  fields: ["sender_company", "sender_name", "sender_phone", "sender_email", "receiver_company",
    "receiver_name", "other_party_contact", "goods_description", "weight", "dangerous_goods",
    "po_number", "external_ref"],
  slots: { "vehicle.picklists": "Vehicle type", "qa.temperatures": "Temperature" },
  tabs: { goods: "Sender + Receiver sections" },
};
export const PEEK_FIELDS = ["sender_company", "receiver_company", "po_number", "manifest_number", "internal_ref", "external_ref"];

function build() {
  const map = { tab: {}, slot: {}, field: {} };
  const add = (scope, key, kind, text) => ((map[scope][key] ||= []).push({ kind, text }));

  for (const card of cardsFor({})) {
    add("tab", card.tab, "card", `Site Checks "${card.title}" confirm card`);
    add("tab", card.tab, "rule", "QA auto-issue on completion (only if tab visible)");
    for (const r of card.rows) {
      if (r.s) add("slot", r.s, "card", `${card.title} card · ${r.label}`);
      else [].concat(r.f).forEach((k) => add("field", k, "card", `${card.title} card · ${r.label}`));
    }
  }
  add("slot", "qa.confirm-cards", "rule", "QA auto-issue on completion (off when hidden)");
  add("tab", "qa", "rule", "QA auto-issue on completion (off when hidden)");
  add("slot", "qa.temperatures", "card", 'FLD block · "Temp set (at load)?"');

  PRINT.fields.forEach((k) => add("field", k, "print", "Booking print page"));
  Object.entries(PRINT.slots).forEach(([k, t]) => add("slot", k, "print", `Booking print · ${t}`));
  Object.entries(PRINT.tabs).forEach(([k, t]) => add("tab", k, "print", `Booking print · ${t}`));
  PEEK_FIELDS.forEach((k) => add("field", k, "peek", "Dock Manager hover box"));
  Object.entries(PLACEHOLDER_SOURCES).forEach(([ph, src]) =>
    add(src.f ? "field" : "slot", src.f || src.s, "email", `Email placeholder {{${ph}}}`));
  return map;
}

export const USAGE = build();
export const usageFor = (scope, key) => USAGE[scope][key] || [];

const KIND_TITLE = { card: "Site Checks", print: "Print", peek: "Dock Manager", email: "Emails", rule: "Database rule" };

/** Everything that goes dark when this switch is turned off (a tab includes its fields + slots). */
export function hideImpact(scope, key, { fields = [], slots = [] } = {}) {
  let uses = usageFor(scope, key);
  if (scope === "tab") {
    fields.filter((f) => f.tab === key).forEach((f) => { uses = uses.concat(usageFor("field", f.key)); });
    slots.filter((s) => s.tab === key).forEach((s) => { uses = uses.concat(usageFor("slot", s.key)); });
  }
  const by = {};
  for (const u of uses) (by[u.kind] ||= new Set()).add(u.text);
  return Object.entries(by).map(([kind, set]) => {
    const items = [...set];
    const head = items.slice(0, 3).join("; ");
    return `${KIND_TITLE[kind]}: ${head}${items.length > 3 ? ` (+${items.length - 3} more)` : ""}`;
  });
}
